import { render } from "./Team.vue?vue&type=template&id=24b1f2ea&lang=pug"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"

import "./Team.vue?vue&type=style&index=0&id=24b1f2ea&lang=scss"

import exportComponent from "/schmetterlinge/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__